import { render, staticRenderFns } from "./NoticeText.vue?vue&type=template&id=32499f97&scoped=true"
import script from "./NoticeText.vue?vue&type=script&lang=js"
export * from "./NoticeText.vue?vue&type=script&lang=js"
import style0 from "./NoticeText.vue?vue&type=style&index=0&id=32499f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32499f97",
  null
  
)

export default component.exports